import { render, staticRenderFns } from "./CellRendererActionsArticles.vue?vue&type=template&id=7c894108&"
import script from "./CellRendererActionsArticles.vue?vue&type=script&lang=js&"
export * from "./CellRendererActionsArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports